/**
 * Jaron, Monday call 2026-10-05 (ticket 13213612910, confirmed by Luis in
 * #dev-luis-samuel 2026-10-07): on a cash deal with HomeCam selected as the
 * contract company, the HomeCam logos must NOT show in the contract (header
 * and watermark). Only for signing-v2 customers, so a contract already signed
 * with the logo keeps it (V67).
 */
export const hideHomeCamCashLogo = ({
  paymentMethod,
  shortName,
  signingV2,
}: {
  paymentMethod: string | undefined
  shortName: string
  signingV2: boolean
}): boolean => signingV2 && shortName === 'HC' && paymentMethod === 'cash'
